import { ApiError } from "@/core/types/types";

const CANCELED_STATUS: string = "(canceled)";

const processApiResponse = async (response: Response): Promise<any> => {
  const { ok, url, status, statusText } = response;
  if (ok === false) {
    const { message, fullUrl, ...requestData } = await response.json();
    const data: string = JSON.stringify(requestData);
    const statusValue: string | number =
      status === 408 ? CANCELED_STATUS : status;

    throw new ApiError({
      url: url ? url : fullUrl,
      status: statusValue,
      statusText: `${message}: ${statusText}`,
      data,
    });
  }

  // Check if the response is a PDF
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/pdf")) {
    return response.arrayBuffer(); // Return as ArrayBuffer for PDF
  }

  return response.json(); // For non-PDF responses
};

export default processApiResponse;
